import React, { useRef, useEffect } from "react";

import Box from "./Box";
import AspectRatioBox from "./AspectRatioBox";
import Image from "./Image";
import { useAppContext } from "./AppContext";

function FullSizeProductImage({ image, pb, background }) {
  const { productImageOverlayOpen, clickedImage } = useAppContext();
  const ref = useRef();

  useEffect(() => {
    if (ref.current && productImageOverlayOpen && clickedImage === image.url) {
      ref.current.scrollIntoView();
    }
  }, [clickedImage]);

  return (
    <Box ref={ref} mb={20} key={image.url}>
      <AspectRatioBox pb={pb} background={background}>
        <Image src={image.url} alt={image.name} sizes="100vw" />
      </AspectRatioBox>
    </Box>
  );
}

export default FullSizeProductImage;
